import { type App, inject } from 'vue'
import { isbot } from 'isbot'

const key = 'app.plugin.is-bot'

export function installIsBot(app: App, userAgent: string | undefined): boolean {
    const isBot = isbot(userAgent ?? '')

    app.provide(key, isBot)

    return isBot
}

export function useIsBot(): boolean {
    return inject(key) as boolean
}
